var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "interactions-creator card-item shadowless med-size-text" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.$t("title-register-interaction")))]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "is-small" }, [
          _vm._v(_vm._s(_vm.$t("label-comment"))),
        ]),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.interactionToCreate.comment,
              expression: "interactionToCreate.comment",
            },
          ],
          staticClass: "textarea",
          attrs: { id: "comment", rows: "2" },
          domProps: { value: _vm.interactionToCreate.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.interactionToCreate, "comment", $event.target.value)
            },
          },
        }),
      ]),
      _c("div", [
        _c(
          "div",
          { staticClass: "metadata" },
          [
            _vm._l(_vm.fields, function (field) {
              return [
                field.type === "select"
                  ? _c(
                      "div",
                      { key: field.name, staticClass: "metadata-entry" },
                      [
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: field.title,
                              "custom-class": "has-text-weight-normal",
                            },
                          },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  id: field.name,
                                  size: "is-small",
                                  rounded: "",
                                },
                                on: {
                                  input: function ($event) {
                                    field.onChange ? field.onChange($event) : {}
                                  },
                                },
                                model: {
                                  value: _vm.interactionToCreate[field.name],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.interactionToCreate,
                                      field.name,
                                      $$v
                                    )
                                  },
                                  expression: "interactionToCreate[field.name]",
                                },
                              },
                              _vm._l(field.possibleOptions, function (option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.slug,
                                    domProps: { value: option.slug },
                                  },
                                  [_vm._v(" " + _vm._s(option.name) + " ")]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "datepicker"
                  ? _c(
                      "div",
                      { key: field.name, staticClass: "metadata-entry" },
                      [
                        _c("label", { attrs: { for: field.name } }, [
                          _vm._v(_vm._s(field.title)),
                        ]),
                        _c("b-datepicker", {
                          attrs: {
                            id: field.name,
                            rounded: "",
                            position: "is-top-left",
                            size: "is-small",
                            locale: "es-ES",
                          },
                          model: {
                            value: _vm.interactionToCreate[field.name],
                            callback: function ($$v) {
                              _vm.$set(_vm.interactionToCreate, field.name, $$v)
                            },
                            expression: "interactionToCreate[field.name]",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "text"
                  ? _c(
                      "div",
                      { key: field.name, staticClass: "metadata-entry" },
                      [
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: field.title,
                              "custom-class": "has-text-weight-normal",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.interactionToCreate[field.name],
                                  expression: "interactionToCreate[field.name]",
                                },
                              ],
                              staticClass: "input is-small input-address",
                              attrs: {
                                id: field.name,
                                placeholder: "Dirección",
                              },
                              domProps: {
                                value: _vm.interactionToCreate[field.name],
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.interactionToCreate,
                                    field.name,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                field.type === "timePicker"
                  ? _c(
                      "div",
                      { key: field.name, staticClass: "metadata-entry" },
                      [
                        _c("label", { attrs: { for: field.name } }, [
                          _vm._v(_vm._s(field.title)),
                        ]),
                        _c("b-timepicker", {
                          attrs: {
                            id: field.name,
                            rounded: "",
                            size: "is-small",
                            locale: "es-ES",
                            placeholder: "Seleccione una hora",
                          },
                          model: {
                            value: _vm.interactionToCreate[field.name],
                            callback: function ($$v) {
                              _vm.$set(_vm.interactionToCreate, field.name, $$v)
                            },
                            expression: "interactionToCreate[field.name]",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm.errorMessage
        ? _c("p", { staticClass: "help is-danger" }, [
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ])
        : _vm._e(),
      _c(
        "b-field",
        { staticClass: "is-grouped is-grouped-right" },
        [
          _c(
            "b-button",
            {
              staticClass: "is-button-primary",
              attrs: {
                id: "create-new-interaction",
                disabled: _vm.buttonIsDisabled,
                rounded: "",
              },
              on: {
                click: function ($event) {
                  return _vm.createNewInteraction()
                },
              },
            },
            [_vm._v(" Registrar ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }